import axios from "../../../utils/request"
function GET_LIST(params) {
    return axios.get("/feedback/MFeedback/index", {
        params: {
            ...params
        }
    })
}
function GET_DETAILS_DATA(params) {
    return  axios.get("/feedback/MFeedback/detail",{
        params: {
            id:params
        }
    } )
}
export default {
    GET_LIST,
    GET_DETAILS_DATA
}